<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading"> How startups can prepare for market turbulence
</h1>	

                <span class="meta"> Posted in May 2022 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/turbulence_bw.png" alt="">
                </figure>
                
<p>Dear startup founders in Japan,</p>



<p>Many of you are keeping your heads down, focused on building transformative projects. Good for you, and good for not being too distracted by the macroeconomic environment.</p>



<p>However, it is important to be remotely aware of what’s happening in the global markets right now, as this will likely trickle down to affect your own next round of fundraising.</p>



<h4><strong>For a quick oversimplification of macro events since the start of 2022&#8230;</strong></h4>



<p>Inflation data in the U.S. clocked in much higher than expectations, apparently surprising many at the U.S. Federal Reserve that inflation was more than just transitory. Consequently, Federal Reserve Chairman Jerome Powell signaled to markets the Fed&#8217;s intention to hike interest rates and begin quantitative tightening in order to tame inflation. Since the start of the year, $1 trillion of liquidity has been withdrawn (in anticipation of quantitative tightening), and the Fed has raised interest rates by 0.75%.</p>



<p>Because the Fed seems to be behind the curve on taming inflation, these measures will likely persist until something breaks (i.e. the beatings will continue until morale improves).</p>



<p>Upon hearing this policy shift, public equities in the U.S. have been nose-diving, led especially by high-growth tech stocks whose valuations were predicated upon an environment of near zero interest rates.</p>



<p>(A discounted cash flow valuation model reflects company cash flows in the numerator and cost of capital in the denominator. When interest rates are low, the cost of capital is low hence the DCF calculation is high. Conversely, raising interest rates mean a rising cost of capital, which increases the denominator in the DCF calculation, hence plunging the equity value of the company).</p>



<p>Declines in public markets usually affect other asset classes. For example, pensions funds may need to reduce their exposure to private equity for portfolio re-balancing.</p>



<p>Crossover hedge funds like Tiger Global have similarly <a href="http://rude.vc/u5lj" target="_blank" rel="noreferrer noopener">abandoned late-stage venture deals</a>. Hitting closer to home, on Friday Softbank&#8217;s Vision Fund <a href="http://rude.vc/nfnV" target="_blank" rel="noreferrer noopener">announced</a> a ¥2.7 trillion loss on its portfolio and its intentions to slow new VC investments.</p>



<p>If history is any guide, pressure on these late-stage fundings will eventually trickle down to early-stage startups. Anecdotally, I&#8217;ve recently begun hearing incidents of this already occurring in Silicon Valley among the latest Y Combinator cohort.</p>



<p>It remains unclear to what extent this wave will ripple through to other VC ecosystems like Japan. At Shizen Capital, we have not seen evidence of this phenomenon here yet but are paying close attention.</p>



<h4><strong>So for startup founders in Japan, what are the potential implications of all this ?</strong></h4>



<p>First, new fundraisings might take longer. Between slowing their investment pace and focusing on their existing portfolios, VC funds may have less capital, and time, to allocate to new deals.</p>



<p>Traditionally conservative VCs in Japan may adopt a wait-and-see approach, thus prevaricating even longer before committing to new financing rounds, especially for early-stage startups.</p>



<p>Secondly, VC deal terms may become stricter. Liquidation and participation preferences, anti-dilution ratchets, and governance covenants may toughen.</p>



<p>Finally, valuations may decline, starting with the later Series C, D, E+ rounds, and eventually affecting the Seed and Series A rounds.</p>



<p>Startups that pegged a high valuation in their Series A or B rounds may struggle to clear the valuation hurdle in their Series C round unless they have dramatically over-performed.</p>



<p>Because down rounds are disruptive, the probability of successful completion of them is lower. This means that startups who priced their last round too high might fail to raise a new round in this environment.</p>



<p>Startups that have been layering SAFE or JKISS notes may find themselves in a particularly challenging conundrum on their cap table (see <a href="http://rude.vc/SAFE" target="_blank" rel="noreferrer noopener">Five reasons SAFE notes may not prove as safe as hoped</a>).</p>



<h4><strong>Not all doom and gloom</strong></h4>



<p>I realize that the above sounds depressing, but I do see some mitigating and even positive factors for our particular startup ecosystem here in Japan.</p>



<p>For one, the frothy valuations in the U.S. and Europe have not permeated Japan as extensively. There are of course some exceptions, and we’ve taken a pass on several deals recently for this reason.</p>



<p>Another factor is that the market demand for the products of startups in Japan remains robust. For Instance, Japan’s corporate and healthcare sectors are in desperate need of DX software solutions, and they cannot afford to deprive themselves of buying from innovative startup vendors.</p>



<p>Furthermore, at the macro level the Bank of Japan is not following the same playbook as the Fed and the European Central Bank. The BOJ&#8217;s maintaining yield curve control keeps interest rates low and money loose, at least for now. (The sharp depreciation of the JPY vs USD has been a direct casualty of this policy, by the way).</p>



<h4><strong>Okay, so how should startup founders respond to these challenges ?</strong></h4>



<p>Startups that are well-capitalized and executing on their projections probably have nothing to worry about. Moreover, if the situation degrades further there may be market opportunities to seize.</p>



<p>For startups currently in fundraising mode, it would be prudent to avoid the mistake of setting valuation expectations too high. It&#8217;s always easier to adjust upward then downward.</p>



<p>Additionally, founders who are currently raising should make an honest assessment of the status of their discussions with VCs. Are you receiving genuine and concrete investment interest from VCs, or rather just encouraging words out of courtesy ? How long is the VC&#8217;s investment process ? Are you talking to VCs who typically lead rounds, or prefer to follow ? (for reference here’s an <a href="http://rude.vc/0JuP" target="_blank" rel="noreferrer noopener">infographic</a> on the most prolific lead VCs in Japan).</p>



<p>One final positive note: cycles are more compressed now than ever before. If we do experience a stretch of pain, it might well be short-lived. Those who survive it will emerge stronger.</p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

